// Cliente REST a lealify-base (re-cableo del manager, reemplazo de Firebase).
// La sesión va por cookie httpOnly (credentials:'include'); cross-site requiere que
// lealify-base corra con CORS_ORIGINS=<origen del manager> y COOKIE_SAMESITE=none.
// Base URL por env VITE_BASE_API_URL (p.ej. https://panel.lealify.com/api); '/api' si mismo-origen.

const BASE: string = (import.meta.env.VITE_BASE_API_URL as string) || '/api';

export class BaseApiError extends Error {
  status: number;
  data: unknown;
  constructor(message: string, status: number, data: unknown) {
    super(message);
    this.name = 'BaseApiError';
    this.status = status;
    this.data = data;
  }
}

async function request<T>(method: string, path: string, body?: unknown): Promise<T> {
  const opt: RequestInit = { method, credentials: 'include', headers: {} };
  if (body !== undefined) {
    (opt.headers as Record<string, string>)['Content-Type'] = 'application/json';
    opt.body = JSON.stringify(body);
  }
  const res = await fetch(BASE + path, opt);
  const txt = await res.text();
  let data: unknown = null;
  try { data = txt ? JSON.parse(txt) : null; } catch { data = { raw: txt }; }
  if (!res.ok) {
    const msg = (data && typeof data === 'object' && 'error' in data)
      ? String((data as { error: unknown }).error) : `HTTP ${res.status}`;
    throw new BaseApiError(msg, res.status, data);
  }
  return data as T;
}

// Descarga un archivo (p. ej. .xlsx) con la sesión. Si el servidor responde error, lanza
// BaseApiError con su mensaje (rango inválido, sin permiso…) en vez de bajar un JSON.
async function download(path: string, fallbackName: string): Promise<void> {
  const res = await fetch(BASE + path, { credentials: 'include' });
  if (!res.ok) {
    let data: unknown = null;
    try { data = await res.json(); } catch { /* sin cuerpo */ }
    const msg = (data && typeof data === 'object' && 'error' in data)
      ? String((data as { error: unknown }).error) : `HTTP ${res.status}`;
    throw new BaseApiError(msg, res.status, data);
  }
  const cd = res.headers.get('content-disposition') || '';
  const name = /filename="([^"]+)"/.exec(cd)?.[1] || fallbackName;
  const url = URL.createObjectURL(await res.blob());
  const a = document.createElement('a');
  a.href = url; a.download = name; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}

export const baseApi = {
  get: <T>(p: string) => request<T>('GET', p),
  post: <T>(p: string, b?: unknown) => request<T>('POST', p, b),
  put: <T>(p: string, b?: unknown) => request<T>('PUT', p, b),
  patch: <T>(p: string, b?: unknown) => request<T>('PATCH', p, b),
  del: <T>(p: string) => request<T>('DELETE', p),
  download,
  baseUrl: BASE,
};
